const DEFAULT_ERROR = 'Something went wrong! Please try again.';

interface ErrorObject extends Error {
  error: Error;
  response?: {
    status: number;
    data: ErrorData;
    headers: Record<string, string>;
  };
  request?: Error;
  config?: string;
}

type ErrorData = {
  errors?: Array<Error>;
  error?: Error;
  httpStatus?: string;
  httpResponseCode?: string;
  message?: string;
};

export function isApiResponseError(err: ErrorObject) {
  return Boolean(err.response);
}

export function isApiRequestError(err: ErrorObject) {
  return Boolean(err.request);
}

// handle endpoints that return multiple errors
// ex: /api/v1/users/properties/specialOffers/createOrUpdate
const hasMultipleErrors = (errorData: ErrorData) => {
  return errorData && errorData.errors !== undefined;
};

const hasNoErrorDataAndNoErrorProperty = (errorData: ErrorData) => {
  return errorData === undefined;
};

// handle endpoints that return errorData but do not return error property
const hasErrorDataButNoErrorProperties = (errorData: ErrorData) => {
  return errorData && errorData?.error === undefined && errorData?.errors === undefined;
};

export const formatError = (errorData: ErrorData) => {
  const rawErrorsCopy = null;

  if (hasErrorDataButNoErrorProperties(errorData)) {
    const { httpResponseCode, message } = errorData;

    const errorObj = {
      data: errorData,
      message,
      httpStatus: httpResponseCode,
    };

    return { errorObj, rawErrorsCopy };
  }

  if (hasMultipleErrors(errorData)) {
    const errorObj = { message: DEFAULT_ERROR };

    return { errorObj, rawErrorsCopy: errorData.errors };
  }

  if (hasNoErrorDataAndNoErrorProperty(errorData)) {
    const errorObj = { message: DEFAULT_ERROR };

    return { errorObj, rawErrorsCopy };
  }

  const errorCopy = { ...errorData?.error, httpStatus: '' };
  if (errorData?.httpStatus !== undefined) {
    errorCopy.httpStatus = errorData?.httpStatus;
  }

  return { errorCopy, rawErrorsCopy };
};
